import { Col, Divider, Row } from "antd";
// import { useCallback, useEffect, useState, useMemo } from "react";
import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import { getApis } from "../../../Common/apis";
// import { imeiListApiUrl } from "../../../Common/endpoints";
import VehicleFilter from "./Filter";
import dataList from "./DataList.json";
import PanelsRow from "../../../Common/Grafana/PanelsRow";
import ChartFilter from "../../../Common/ChartFilter";
import { BATTERY_STATUS } from "../../../Common/Grafana/Constants";
import {
  getGrafanaBaseURL,
  getGrafanaBatteryDataInterval,
  getGrafanaBatteryStackInterval,
  getGrafanaBatteryCellInterval,
} from "../../../Common/Utils";
// import { setImeiList } from "../../../../reducers/eolSlice";
import { setPageLoader } from "../../../../reducers/loaderSlice";
import SensorPanels from "./Sensor";

const Vehicle = () => {
  const startTime = useSelector((state) => state.filter.startTime);
  const endTime = useSelector((state) => state.filter.endTime);
  // const imeiList = useSelector((state) => state.eol.imeiList);
  const [vehicle, setVehicle] = useState({});
  // const [imei, setImei] = useState(imeiList[0]);
  // const authToken = localStorage.getItem("authToken");
  const dispatch = useDispatch();
  const [chartType, setChartType] = useState({
    timeSeries: true,
    histogram: false,
    boxPlot: false,
  });

  const baseFilterObject = useMemo(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    return {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      vehicle_id: vehicle?.vehId,
      bucket_interval: getGrafanaBatteryDataInterval(startTime, endTime),
      from: startTime,
      to: endTime,
    };
  }, [vehicle?.vehId, startTime, endTime]);

  const baseBatteryStackFilterObject = useMemo(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    return {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      vehicle_id: vehicle?.vehId,
      bucket_interval: getGrafanaBatteryStackInterval(startTime, endTime),
      from: startTime,
      to: endTime,
    };
  }, [vehicle?.vehId, startTime, endTime]);

  const baseBatteryCellFilterObject = useMemo(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    return {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      vehicle_id: vehicle?.vehId,
      bucket_interval: getGrafanaBatteryCellInterval(startTime, endTime),
      from: startTime,
      to: endTime,
    };
  }, [vehicle?.vehId, startTime, endTime]);

  const updateChartType = (name, value) => {
    setChartType((prev) => ({ ...prev, [name]: value }));
  };

  // const getImeiList = useCallback(async () => {
  //   await getApis(imeiListApiUrl, {}, authToken)
  //     .then((response) => {
  //       dispatch(setImeiList(response?.data));
  //       setImei(response?.data[0]);
  //       dispatch(setPageLoader(null));
  //     })
  //     .catch((e) => {
  //       toast.error(e.response?.data?.message);
  //       dispatch(setPageLoader(null));
  //     });
  // }, [authToken, dispatch]);

  useEffect(() => {
    // getImeiList();
    dispatch(setPageLoader("refresh"));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeImei = (_, value) => {
    dispatch(setPageLoader("refresh"));
    setVehicle(value);
    setTimeout(() => {
      dispatch(setPageLoader(null));
    }, 2000);
  };

  return (
    <div data-testid="vehicle-component">
      <VehicleFilter
        // imeiList={imeiList}
        vehicle={vehicle}
        onChangeImei={onChangeImei}
      />

      <div className="card pd1 mt1">
        <Row justify={"end"}>
          <Col xs={8} sm={6} md={4} lg={3} xl={3}>
            <ChartFilter
              updateChartType={updateChartType}
              chartType={chartType}
            />
          </Col>
        </Row>
        <Divider className="divider-margin" />
        <Row className="pd0">
          {dataList.battery.map((data, index) => (
            <Col span={24} key={index}>
              <PanelsRow
                title={data.title}
                url={getGrafanaBaseURL(
                  BATTERY_STATUS.VEHICLE.DASHBOARD_ID,
                  BATTERY_STATUS.VEHICLE.DASHBOARD_NAME
                )}
                timeSeriesPanel={
                  chartType?.timeSeries &&
                  BATTERY_STATUS.VEHICLE.PANEL_ID["genericData"]["timeSeries"]
                }
                histogramPanel={
                  chartType?.histogram &&
                  BATTERY_STATUS.VEHICLE.PANEL_ID["genericData"]["histogram"]
                }
                boxPlotPanel={
                  chartType?.boxPlot &&
                  BATTERY_STATUS.VEHICLE.PANEL_ID["genericData"]["boxPlot"]
                }
                baseFilterObject={baseFilterObject}
                staticFilterObject={{ batteryfield: data.value }}
                variableKeys={BATTERY_STATUS.VEHICLE.BATTERY_VARIABLES}
              />
            </Col>
          ))}
        </Row>
        <SensorPanels
          chartType={chartType}
          baseBatteryStackFilterObject={baseBatteryStackFilterObject}
          baseBatteryCellFilterObject={baseBatteryCellFilterObject}
        />
      </div>
    </div>
  );
};

export default Vehicle;
